import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconVariable({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M9.042 3.75 5.046 1.497a.093.093 0 0 0-.092 0L.958 3.75a.111.111 0 0 0-.054.097v4.306c0 .04.02.078.054.097l3.996 2.252a.093.093 0 0 0 .092 0L9.042 8.25a.111.111 0 0 0 .054-.097V3.847c0-.04-.02-.078-.054-.097zM5.462.622a.93.93 0 0 0-.923 0L.543 2.875A1.11 1.11 0 0 0 0 3.847v4.306c0 .409.21.784.543.972l3.996 2.253a.93.93 0 0 0 .922 0l3.996-2.253A1.11 1.11 0 0 0 10 8.153V3.847c0-.409-.21-.784-.543-.972L5.461.622z"/>
            <circle fill={fill} cx="5" cy="6" r="1"/>
        </svg>
    );
}

export default IconVariable;

